<template>
  <section>
    <div style="border-radius: 5px;">
      <div>
        <!-- リスト -->
        <template v-if="itemList.length <= 0">
          候補がありませんでした
        </template>
        <template v-else>
          <section class="-tablesection">
            <table class="item-list-table">
              <!-- リストヘッダ -->
              <tr class="table-header">
                <td
                  v-for="(title, headerIndex) in header"
                  :key="headerIndex"
                >
                  {{title}}
                </td>
              </tr>
              <!-- リスト -->
              <tr
                v-for="(line, lineIndex) in itemList"
                :key="lineIndex"
                :class="{selected:activeLine===lineIndex}"
                @mouseover="activeLine=lineIndex"
                @mouseout="activeLine=-1"
              >
                <td
                  @click="selectItem(lineIndex)"
                  v-for="(item, itemIndex) in getline(line)"
                  :key="itemIndex"
                >
                  {{item}}
                </td>
              </tr>
            </table>
          </section>
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'SelectItemList',
  props: {
    /** ヘッダー */
    header    : {
      type    : Array,
      default : [],
      required: true
    },
    /** アイテムリスト */
    itemList  : {
      type    : Array,
      default : [],
      required: true
    }
  },
  data () {
    return {
      /** 選択行 */
      activeLine: -1
    }
  },
  computed: {
    /** 表示部分成形 */
    getline () {
      return function (line) {
        let result = []
        if (line) {
          for (let idx in line) {
            if (idx > 0) {
              // 先頭以外を表示アイテムとして追加する
              result.push(line[idx])
            }
          }
        }
        return result
      }
    },
  },
  methods: {
    /** アイテム選択 */
    selectItem (index) {
      // 選択されたアイテムの先頭を返す
      this.$emit('select-item', this.itemList[index][0])
    }
  }
}
</script>

<style scoped>
.table-section {
  width: 100%;
  height: 120px;
  overflow: scroll;
  border: 1px #ccc solid;
  white-space: nowrap;
}
.table-section::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.item-list-table {
  font-size: 12px;
  width: 100%;
}
.item-list-table::-webkit-scrollbar {
  width: 5px;
}
.selected{
  background-color: #00f;
  color:#fff;
}
th,
td {
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/common/SelectItemList.vue